import React from 'react'
import {hydrate} from 'react-dom'
import {globalJss, ApplyTheme} from 'rambler-ui/theme'

import App from 'containers/App'
import StyleContext from 'isomorphic-style-loader/StyleContext'

import '../style/global.css'
import '../style/variables.css'

globalJss.setup({insertionPoint: 'jss-insertion-point'})

const insertCss = (...styles) => {
  const removeCss = styles.map((x) => x._insertCss())

  return () => {
    removeCss.forEach((f) => f())
  }
}

hydrate(
  <ApplyTheme>
    <StyleContext.Provider value={{insertCss}}>
      <App />
    </StyleContext.Provider>
  </ApplyTheme>,
  document.getElementById('root'),
  () => {
    const styles = [...document.querySelectorAll('.server-styles')]

    if (styles.length === 0) {
      return
    }

    const parent = styles[0].parentNode

    styles.forEach((style) => parent.removeChild(style))
  }
)
